import { render, staticRenderFns } from "./WhatsHoppingNew.vue?vue&type=template&id=47c4e2d5&scoped=true&"
import script from "./WhatsHoppingNew.vue?vue&type=script&lang=js&"
export * from "./WhatsHoppingNew.vue?vue&type=script&lang=js&"
import style0 from "./WhatsHoppingNew.vue?vue&type=style&index=0&id=47c4e2d5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c4e2d5",
  null
  
)

export default component.exports